
const request = ({ }) => {
    return new Promise((resolve, reject) => {
        resolve(true)
    })
}

export { request }